<template>
    <v-container>
        <div class="mx-5">
            <h1 class="title grey--text">DASHBOARD</h1>
        <v-row class="py-4">
          <v-col cols="12" md="4" sm="6" >
            <v-card  class="pa-4" hover>
              <v-card-title class="headline">USERS</v-card-title>
              <v-card-title class="mt-n5 font-weight-black">{{UsersCount}}</v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" sm="6" >
            <v-card class="pa-4" hover >
              <v-card-title class="headline">FARMS</v-card-title>
              <v-card-title class="mt-n5 font-weight-black">{{FarmCount}}</v-card-title>
            
            </v-card>
          </v-col>
           <v-col cols="12" md="4" sm="6" >
            <v-card class="pa-4" hover >
              <v-card-title class="headline">Investments</v-card-title>
              <v-card-title class="mt-n5 font-weight-black">{{InvestCount}}</v-card-title>
            
            </v-card>
          </v-col>
          <!-- <v-col cols="12" md="4" sm="6" >
            <v-card class="pa-4" hover @click="getAds()">
              <v-card-title class="headline">ADVERTS</v-card-title>
              <v-card-title class="mt-n5 font-weight-black">{{advertCount}}</v-card-title>
              
            </v-card>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <v-card
              max-width="450"
            >
              <v-card-title :key="index">Most Recent Users</v-card-title>
              <v-list three-line>
                <template v-for="(item, index) in RecentUsers">
                  
                  <v-divider
                    :key="index"
                    inset
                    v-if="index!==0"
                  ></v-divider>

                  <v-list-item
                    :key="item.title"
                  >
                    <v-list-item-avatar>
                      <!-- <v-img :src="item.avatar"></v-img> -->
                      <v-img  :src="getImageUrl(item.profile_img_url)" lazy-src='/pics.svg'></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title v-html="item.firstname+ ' ' + item.lastname"></v-list-item-title>
                      <v-list-item-subtitle v-html="item.email"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-col>
          <v-col>
            
                 <v-card
              max-width="450"
            >
              <v-card-title :key="index">Recent Transactions</v-card-title>
              <v-list three-line>
                <template v-for="(item, index) in RecentTrans">
                  
                  <v-divider
                    :key="index"
                    inset
                    v-if="index!==0"
                  ></v-divider>

                  <v-list-item
                    :key="item.title"
                  >
                    <v-list-item-avatar>
                      <!-- <v-img :src="item.avatar"></v-img> -->
                      <v-img src="/logo.png" lazy-src='/pics.svg'></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>Amount: &#8358;{{item.amount}}</v-list-item-title>
                      <v-list-item-title class="mt-2">Investment Code: {{item.investment_code}}</v-list-item-title>
                      <v-list-item-subtitle  class="mt-2">Status: {{item.status}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" md="12" sm="12">
            <v-card>
              <v-card-title>
                Recently Added Farms
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="Farms"
                hide-default-footer=""
                items-per-page = 5
                no-data-text='No Recently Added Farms'
              >
                <template v-slot:item.farm_img_url="{ item }">
                  <v-img :src="getImageUrl(item.farm_img_url)" height="60" width="80" class="ma-0" contain></v-img>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-btn text  @click=" getFarmById(item._id)" style="border: 1px #48c074 solid; color:#48c074" class="text-none" small>View</v-btn>
                </template>
                <template v-slot:item.roi="{ item }">
                    <span>{{item.roi}}%</span>
                </template>
                <template v-slot:item.cost="{ item }">
                    <span>&#8358;{{item.cost}}</span>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        
       
        <!-- <v-row>
          <v-col cols="12" md="8">
            <div class="pb-7 mx-auto" v-for="slide in reports" :key="slide" style="background-color: #005792; heigth:700px">
              <LineChart :data="slide.data" :styles="slide.style" :label='slide.label'/>
            </div>
          </v-col>
        </v-row> -->
        </div>
  </v-container>
</template>

<script>
// import LineChart from '../components/LineChart'
export default {
    components:{
      // LineChart
    },
    data(){
        return{
          reports: [
              {title:'Third Party Applications Added', data:[[1,9,10,5,20,23,15]], style:{position: "relative", height: "300px"}, label:'Users'},
              // {title:'Transactions', data:[[3,9,15,10,20,23,25]], style:{position: "relative", height: "300px"}, label:'Transactions'},
          ],
          headers:[
            {
              text: 'Farm Image',
              align: 'start',
              sortable: false,
              value: 'farm_img_url',
            },
            {
              text: 'Name',
              align: 'start',
              sortable: false,
              value: 'name',
            },
            { text: 'Duration', value: 'duration' },
            { text: 'Cost', value: 'cost' },
            { text: 'ROI', value: 'roi' },
            { text: 'Units', value: 'units_avail' },
            { text: '', value: 'action', sortable: false, },
          ],
        users:[
            {username:'oremei.akande@gmail.com', name:'Akander Oremei'},
            {username:'louis.joy@gmail.com', name:'Louis Joy'},
            {username:'sam.ade@gmail.com', name:'Sam Ade'},
            
        ]
            

        }
    },
     computed:{
            FarmCount(){
                return this.$store.state.farm.farmsCount
            },
            UsersCount(){
                return this.$store.state.farm.usersCount
            },
             InvestCount(){
                return this.$store.state.farm.investCount
            },
             Farms(){
              let farm= this.$store.state.farm.farms
              if(farm.length>0){
                for(let j=0; j<farm.length; j++){
                  farm[j].cost = parseFloat(farm[j].cost).toFixed(2)
                  farm[j].cost = farm[j].cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  farm[j].units_avail = farm[j].units_avail.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                }
                
              }
              return farm
            },
            RecentUsers(){
              return this.$store.state.users.recentusers
            },
            RecentTrans(){
              let trans= this.$store.state.transaction.recenttransactions
              if(trans.length>0){
                for(let j=0; j<trans.length; j++){
                  trans[j].amount = parseFloat(trans[j].amount).toFixed(2)
                  trans[j].amount = trans[j].amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
              }
              return trans
            }
             
        },
        methods:{
          getImageUrl(url){
            if(url){
              return url
            }else{
              return '/pics.svg'
            }
          },
          getFarmById(id){
            event.preventDefault()
             this.$store.dispatch("GetFarmsById", id)
            .then((success)=>{
                this.$router.push(`/farms/admin/${success.data._id}`)
            })
            .catch(()=>{
            })
           
        },
        },
     created(){
            this.$store.dispatch("GetFarmsTotal")
            .then(()=>{ 
            })
            .catch(()=>{
            });

            this.$store.dispatch("GetUsersTotal")
            .then(()=>{ 
            })
            .catch(()=>{
            });

            this.$store.dispatch("GetInvestTotal")
            .then(()=>{ 
            })
            .catch(()=>{
            });
            
             this.$store.dispatch("GetFarms")
              .then(()=>{
              })
              .catch(()=>{
              })

               this.$store.dispatch("GetRecentUsers")
              .then(()=>{
              })
              .catch(()=>{
              })

               this.$store.dispatch("GetRecentTransactions")
              .then(()=>{
              })
              .catch(()=>{
              })

        },
    
    
    
}
</script>

<style>

</style>